module.exports = __webpack_public_path__ + "img/fair_catch_left.7d09f312.jpg";